module.exports = __webpack_public_path__ + "img/interrogacaovazada.ed4d931e.svg";